module.exports = __webpack_public_path__ + "static/img/loading.078fcd09.gif";